<template>
  <div class="header">
    <transition name="mobile-menu">
      <div v-if="currentMenu" class="mobile-menu-field col-block width-full" @click="e => currentMenu = null">
        <template v-if="currentMenu === 'main'">
          <div class="mobile-menu-container main row-block height-full" :style="{ flex: 1 }">
            <div :style="{ flex: 1 }"></div>
            <div class="mobile-menu-block" @click.stop>
              <sidebarMain
                :type="'mobile'"
              ></sidebarMain>
            </div>
          </div>
        </template>
      </div>
    </transition>
    <div class="header-field col-block width-full">
      <div class="header-container col-block width-full">
        <div class="header-block row-block">
          <div class="left-container row-block" :style="{ flex: 1 }">
            <a class="logo-container center-block" :style="{ width: '180px' }" :href="externalLinkDatas()['compassbioinfo']" target="_blank">
              <div class="logo-block row-block">
                <div class="logo-icon center-block">
                  <img :src="require('../../assets/icons/compassbioinfo-icon.svg')" alt="" :style="{ 'max-width': '24px' }">
                </div>
                <div class="logo-title">{{ $t('LAYOUT.header.___logoTitle') }}</div>
              </div>
            </a>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div class="center-container">
          </div>
          <div class="right-container row-block" :style="{ flex: 1 }">
            <div :style="{ flex: 1 }"></div>
            <div class="menu-icon-button icon-block" :style="{ '--size': '40px' }" @click="e => currentMenu = (isMobile && !currentMenu ? 'main' : null)">
              <img :src="currentMenu === 'main' ? require('../../assets/menuIcons/menu-close-icon.svg') : require('../../assets/menuIcons/menu-open-icon.svg')" alt="" :style="{ 'max-width': '30px' }">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarMain from '../sidebar/main.vue'
import toastMethods from '../../mixins/toastMethods.vue'
import responsitive from '../../mixins/responsitive.vue'
import locale from '../../mixins/locale.vue'
import loginData from '../../mixins/loginData.vue'
import { externalLinkDatas } from '../../constants/global/data'

export default {
  components: {
    sidebarMain
  },
  mixins: [
    toastMethods,
    responsitive,
    locale,
    loginData
  ],
  data () {
    return {
      currentMenu: null
    }
  },
  computed: {
    ...mapGetters([
      'isLogin',
      'user'
    ]),
    // global
    externalLinkDatas () { return externalLinkDatas }
  },
  watch: {
    '$route' () {
      this.currentMenu = null
    },
    'afkCountDown.value' (nv) {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/header.vue